import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderFilledIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5 17.5C19.0304 17.5 19.5391 17.2893 19.9142 16.9142C20.2893 16.5391 20.5 16.0304 20.5 15.5V5.5C20.5 4.96957 20.2893 4.46086 19.9142 4.08579C19.5391 3.71071 19.0304 3.5 18.5 3.5H10.6C10.2655 3.50328 9.93555 3.42261 9.6403 3.26538C9.34505 3.10815 9.09396 2.87938 8.91 2.6L8.1 1.4C7.91789 1.12347 7.66997 0.896479 7.3785 0.739396C7.08702 0.582314 6.76111 0.500055 6.43 0.5H2.5C1.96957 0.5 1.46086 0.710714 1.08579 1.08579C0.710714 1.46086 0.5 1.96957 0.5 2.5V15.5C0.5 16.0304 0.710714 16.5391 1.08579 16.9142C1.46086 17.2893 1.96957 17.5 2.5 17.5H18.5Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFolderFilledIcon;
